import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AccountActivationPage } from './account-activation';
import { ComponentsModule } from '../../components/components.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    AccountActivationPage,
  ],
  imports: [
    IonicPageModule.forChild(AccountActivationPage),
    ComponentsModule,
    TranslateModule
  ],
})
export class AccountActivationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/account-activation/account-activation.module.ts